export default "__VITE_ASSET__HCdnf2zX__"